const horseInfo__titleImage = document.querySelector(".horse-info__title-image");
const horseInfo_lightGalleryContainer = document.querySelector(".horse-info__lightgallery-container");

if (horseInfo__titleImage && horseInfo_lightGalleryContainer) {
    horseInfo__titleImage.addEventListener("click", (e) => {
        horseInfo_lightGalleryContainer.firstElementChild.click();
    });
}
